<template>
  <div class="invoice-manage">
    <!-- Tab 切换 -->
    <div class="tab-box content-wrapper">
      <div class="tab-items">
        <div
          class="tab-item"
          :class="{ active: activeTab === 'handle' }"
          @click="onTabChange('handle')"
        >
          开票处理
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'setting' }"
          @click="onTabChange('setting')"
        >
          开票设置
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === 'platform' }"
          @click="onTabChange('platform')"
        >
          平台给我开票
        </div>
      </div>
      <!-- 开票处理列表搜索（keyword 通过参数下发给子组件控制搜索） -->
      <div v-if="activeTab === 'handle'" class="tab-search">
        <input
          v-model="keywordInput"
          type="text"
          placeholder="搜索订单号/买家名称"
          @keyup.enter="onTabSearch"
          @compositionend="onTabSearch"
        />
        <img
          class="search-icon-btn"
          src="@/assets/images/icon-search.png"
          alt=""
          @click="onTabSearch"
        />
      </div>
    </div>

    <!-- Tab 内容 -->
    <InvoiceHandleTab v-if="activeTab === 'handle'" :keyword="keyword" />
    <InvoiceSettingTab v-if="activeTab === 'setting'" />
    <PlatformInvoiceTab v-if="activeTab === 'platform'" />
  </div>
</template>

<script>
import InvoiceHandleTab from './components/InvoiceHandleTab.vue'
import InvoiceSettingTab from './components/InvoiceSettingTab.vue'
import PlatformInvoiceTab from './components/PlatformInvoiceTab.vue'

export default {
  name: 'ShopInvoiceManage',
  components: {
    InvoiceHandleTab,
    InvoiceSettingTab,
    PlatformInvoiceTab,
  },
  data() {
    return {
      activeTab: 'handle',
      keywordInput: '',
      keyword: '',
    }
  },
  methods: {
    onTabChange(tab) {
      this.activeTab = tab
    },
    // 确认搜索关键字，下发到子组件触发搜索
    onTabSearch() {
      this.keyword = this.keywordInput
    },
  },
}
</script>

<style lang="scss" scoped>
@import './components/invoice-common.scss';

.invoice-manage {
  width: 100%;
  height: 100%;

  // Tab
  .tab-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 0 !important;

    .tab-items {
      display: flex;
      align-items: center;
      gap: 40px;
    }

    // 右侧搜索框
    .tab-search {
      display: flex;
      align-items: center;
      gap: 8px;
      background: #f3f4f6;
      border-radius: 24px;
      padding: 8px 16px;
      width: 280px;
      box-sizing: border-box;

      input {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        font-size: 14px;
        min-width: 0;
      }

      .search-icon-btn {
        width: 22px;
        height: 22px;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }

  .tab-item {
    font-size: 16px;
    color: #666666;
    padding-bottom: 16px;
    cursor: pointer;
    position: relative;

    &.active {
      color: #1a1a1a;
      font-weight: bold;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: #ff5967;
      }
    }

    &:hover {
      color: #1a1a1a;
    }
  }
}
</style>
